import { reactive, toRefs } from "vue";
import Cookies from "js-cookie";

const state = reactive({
  isMenuCollapsed: Cookies.get("isMenuCollapsed") === "true",
});

function toggleMenu() {
  state.isMenuCollapsed = !state.isMenuCollapsed;
  Cookies.set("isMenuCollapsed", state.isMenuCollapsed);
}

export function useGlobalState() {
  return {
    ...toRefs(state),
    toggleMenu,
  };
}
